import ScriptModel from '@src/initialize/inject-scripts/libs/script-model';

export const weinre = new ScriptModel({
  condition: ~window.location.search.indexOf('__DEBUG__'),
  script: 'http://npm-registry.seasungame.com:10001/target/target-script-min.js#anonymous'
});

export const vconsole = new ScriptModel({
  condition: ~window.location.search.indexOf('__VCONSOLE__'),
  script: 'https://npm-registry.seasungame.com/xfe-static/libs/vconsole/3.1.1/vconsole.min.js',
  resolve: () => new window.VConsole()
});

/**
 * 拦截 jsonp 并输入 console.log
 */
export const interceptJsonp = new ScriptModel({
  condition: ~window.location.search.indexOf('__INTERCEPT_JSONP__'),
  // 允许外网, 内部代码目前使用 console.log 的形式, 问题不大
  script: '//zhcdn01.xoyo.com/xassets/lib/intercept-jsonp/0.0.1/main.es6.js'
});

/**
 * 百度统计
 * @type {ScriptModel}
 * @private
 */
export const internalConcreteNavConfig = new ScriptModel({
  condition: ~window.location.search.indexOf('__NAV__'),
  script: ['internal-access---concrete-nav-config.js', '//zhcdn01.xoyo.com/xassets/lib/concrete-nav/0.0.x/concrete-nav.umd.js'],
  resolve: () => {
    window.concreteNav(window.INTERNAL_CONCRETE_NAV_CONFIG);
  }
});

/**
 * 百度统计
 * @type {ScriptModel}
 * @private
 */
export const baiduStatistic = new ScriptModel({
  condition: !!process.env.BAIDU_STATISTIC_ACCOUNT,
  script: `//hm.baidu.com/hm.js?${process.env.BAIDU_STATISTIC_ACCOUNT}`,
  prepare: () => (window['_hmt'] = window['_hmt'] || [])
});

/**
 * 751Code统计
 * @type {ScriptModel}
 * @private
 */
export const _751CodeStatistic = new ScriptModel({
  script: '//zhcdn01.xoyo.com/xassets/lib/751code/https/o_code.js'
});

/**
 * 通用统计
 * @type {ScriptModel}
 */
// export const commonStatistic = new ScriptModel({
//   script: '//zhcdn01.xoyo.com/xassets/lib/footer-track/0.0.x/footer-track.umd.js'
// });
